module.exports = __webpack_public_path__ + "media/images/lp_v6_img06-215593ffc5cf2ec7a8a8ff4c3ae72433.webp";